import { StringSchema } from "yup";
import { EValidacaoNomeada } from "../../../../@types/IntegracaoCampoEnum";

export default function useNamedStringValidators() {
  type TApplyValidation = (base: StringSchema) => StringSchema;

  const CNPJ_REGEX =
    /^[A-Z0-9]{2}\.?[A-Z0-9]{3}\.?[A-Z0-9]{3}\/?[A-Z0-9]{4}-?\d{2}$/i;
  const CPF_REGEX = /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/;
  const MASKED_CPF_REGEX = /^\*{3}\.\*{3}\.\d{3}-\d{2}$/;
  const PHONE_REGEX = /^\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/;
  const DIGITS_REGEX = /^\d+$/;

  const validatorRegistry: Record<EValidacaoNomeada, TApplyValidation> = {
    [EValidacaoNomeada.Cnpj]: (base) =>
      base.matches(CNPJ_REGEX, "CNPJ inválido"),
    [EValidacaoNomeada.Cpf]: (base) =>
      base.matches(new RegExp(`(?:${CPF_REGEX.source})|(?:${MASKED_CPF_REGEX.source})`), {
        message: "CPF inválido",
        excludeEmptyString: true
      }),
    [EValidacaoNomeada.Email]: (base) => base.email("E-mail inválido"),
    [EValidacaoNomeada.Url]: (base) => base.url("URL inválida"),
    [EValidacaoNomeada.HttpsUrl]: (base) =>
      base.test(
        "https-url",
        "URL inválida. Informe uma URL iniciando com https://",
        (value) => {
          if (!value) return true;
          try {
            return new URL(value).protocol === "https:";
          } catch {
            return false;
          }
        }
      ),
    [EValidacaoNomeada.Telefone]: (base) =>
      base.matches(PHONE_REGEX, "Telefone inválido"),
    [EValidacaoNomeada.Digits]: (base) =>
      base.matches(DIGITS_REGEX, {
        message: "Deve conter apenas números",
        excludeEmptyString: true
      })
  };

  const applyNamedValidation = (
    base: StringSchema,
    name: EValidacaoNomeada | null
  ): StringSchema => (name ? validatorRegistry[name](base) : base);

  return {
    applyNamedValidation,
    validatorRegistry
  };
}
